module.exports = __webpack_public_path__ + "assets/img/The-Dream-Collective-Website.59921601.jpg";